
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate2.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Dietitian Experts',
      queryName: 'Dietitian',
      teamName: 'Dietitian team',
    };
  },
  components: { DoctorsList },
});
